<template>
  <BaseModal overlay-class="lantern_modal">
    <div class="content">
      <template v-if="successful">
        <h1>{{ $_translations.value.modal_post_game_puzzle_success_title }}</h1>

        <p>{{ $_translations.value.modal_post_game_puzzle_success_subtitle }}</p>

        <BaseImage
          src="/static/images/puzzle/puzzle_sign.svg"
          image-class="middle_img"
          alt="puzzle"
        />

        <p>{{ $_translations.value.modal_post_game_puzzle_success_you_earned }}</p>

        <RewardBoxItem :prize-value="prizeValue" />
      </template>

      <template v-else>
        <h1>{{ $_translations.value.modal_post_game_puzzle_failed_title }}</h1>

        <p>{{ $_translations.value.modal_post_game_puzzle_failed_subtitle }}</p>

        <BaseImage
          src="/static/images/puzzle/puzzle_sign.svg"
          image-class="middle_img"
          alt="puzzle"
        />

        <p>
          {{ $_translations.value.modal_post_game_puzzle_failed_description_pt1 }}<br>
          {{ $_translations.value.modal_post_game_puzzle_failed_description_pt2 }}
        </p>
      </template>

      <BaseButton @click:button="$emit('close')">
        {{ $_translations.value.modal_post_game_puzzle_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>
<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import RewardBoxItem from '@/components/item/RewardBoxItem.vue';

defineEmits(['close']);

defineProps({
  successful: {
    type: Boolean,
    default: false,
  },
  prizeValue: {
    type: Number,
    default: 0,
  },
});
</script>
